export function useHotjar() {
    function publishEvent(name: string) {
        if (window.hj) {
            window.hj('event', name);
        } else {
            window.addEventListener('hotjar_loaded', () => {
                if (window.hj) {
                    window.hj('event', name);
                }
            });
        }
    }
    return {
        publishEvent,
    };
}
